import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
// import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
// import LookupReceiptSaleModal from "../../../components/Modal/LookupReceiptSaleModal";
import { Link } from "react-router-dom";
// import Loader from "../../../components/Loader/Loader";
// import Sidebar from "../../Dashboard/Sidebar/Sidebar";
// import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import {CUSTOM_SELECT_DROPDOWN_STYLE} from "../../../../common/Constant";
import Select from "react-select";
// import { Dash1, Dash2, Dash3, Dash4 } from "../../../common/imagePath";
import CountUp from "react-countup";
import moment from "moment";
import config from "../../../../config/config";


const Task = (props) => {
  let selectData = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(3);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState();
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const[employeeDropdown,setEmployeeDropdown]=useState([])

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const options1 = [
    {label:"All",value:1},
    {label:"Completed",value:2},
    {label:"Incompleted",value:3}
  ]
  
  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  //Status
  const[statusOptions,setStatusOptions] = useState({
    label:"All",
    value:1
  })

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     color:"#000",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color:state.isActive?"#000":"#000",
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       color: "#000",
  //       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
  //     },
  //   }),
  // };

  //Employee Dropdown Data
  let employeeOptions = [];
  const employeeDropDownData = employeeDropdown.map((u, i) => {
    employeeOptions[i] = {
      label: u.Name,
      value: u.Id,
    };
  });

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  console.log("QuickBookOptions::>>", quickBookOptions);
  const handleQuickBookChange = (event) => {
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
       const lastWeekStartDate = moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD');
      const lastWeekEndDate = moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD');

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf('week').format('YYYY-MM-DD');
      const lastWeekEndDate = moment().endOf('week').format('YYYY-MM-DD');
      console.log("lastWeekStartDate: " + lastWeekStartDate, "| " + "lastWeekEndDate" + lastWeekEndDate);

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
    
      const lastMonthStartDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      const lastMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const firstdate = moment().startOf('month').format('YYYY-MM-DD');
      const lastdate = moment().endOf('month').format('YYYY-MM-DD');

      setStartingDate(firstdate);
      setEndingDate(lastdate);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  useEffect(() => {
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD');
      const lastWeekEndDate = moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD');

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
    const currentWeekStartDate = moment().startOf('week').format('YYYY-MM-DD');
      const currentWeekEndDate = moment().endOf('week').format('YYYY-MM-DD');

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
     
      const lastMonthStartDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
      const lastMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    } 
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf('month').format('YYYY-MM-DD');
      const currentLastDate = moment().endOf('month').format('YYYY-MM-DD');

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    
    } 
    else {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);


  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      console.log(e.selectedRows.map((x) => x.ID));

      const selectedSalesCheckboxIds =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedSalesCheckboxIds(selectedSalesCheckboxIds);
      console.log(selectedSalesCheckboxIds);
    }
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    startingdate,
    endingdate,
    salestypeid,
    customerid
  ) => {
    setLoading(true);

    salestypeid = salestypeid > 0 ? salestypeid : 0;
    customerid = customerid > 0 ? customerid : 0;
  };
  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      saleids: pID || selectedSalesCheckboxIds,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  useEffect(() => {
    if (quickBookOptions?.value !== 2) {
      handleListData(
        1,
        perPageSize,
        searchtext,
        sortingId,
        sortingDirection,
        startingDate,
        endingDate,
        salesTypeID,
        customerID
      );
    }
  }, [salesTypeID, customerID, quickBookOptions]);

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [data, selectedRows, toggleCleared]);

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };
  // Table Data
  const columns = [
    {
      name: "TASK NAME",
      selector: row => row["Task"],
      sortable: true,
      width: "600px",
    },
    {
      name: "ASSIGNED TO",
      selector: row => row["Assigned To"],
      sortable: true,
      width: "180px",
    },
    {
      name: "DUE DATE",
      selector: (row) => formatDate(row.Saletime),
      sortable: true,
      width: "130px",
    },
    {
      name: "ACTIONS",
      selector: row => row["Actions"],
      sortable: false,
      width: "200px",
    },
    {
      name: "VIEW NOTES",
      selector: row => row["View Notes"],
      sortable: false,
      width: "130px",
    },
  ];

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  // generate new columns according to hiddenColumns data and pass it as datatable column
  
  const filteredColumns = columns.filter(
    (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  );

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(
      page,
      newPerPage,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID
    );
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(
      page,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID
    );
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID
    );
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(
      1,
      perPageSize,
      e.target.value,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID
    );
    console.log(handleListData);
  };

  
  useEffect(() => {
    axios
    .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        Authorization: token,
      },
    })
    .then((res) => {
      console.log("employee", res);
      setEmployeeDropdown(res.data.ResponseData);
      // setLoading(false);

      return res;
    });
  }, []);

  return (
    <>
      {/* <Loader loading={loading} /> */}
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Tasks</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Task</li>
              </ul>
            </div>
            <div className="btn-group pull-right ms-2 ">
               <div className="me-2">
                <Link 
                className="btn btn-primary btn-sm pull-right" style={{ width: "max-content" }}
                to={`/manage-task`}>
                <i className="fa fa-plus me-2 lg"></i> Add Task
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10 col-md-10 col-sm-12">
              <div className="d-flex flex-wrap">
                <div className="p-3 col-md-3">
                  Date Filter:
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange(event);
                    }}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    className="custom-search-select"
                  />
                </div>
                <div className="p-3 col-lg-2 col-md-6 col-sm-12 ">
                    Status:
                 <Select
                    defaultValue="All"
                    // onChange={(event) => {
                    //   handleQuickBookChange(event);
                    // }}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                    options={options1}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    className="custom-search-select"             
                 />
                </div>
                <div className="p-3 col-md-3">
                    Assigned To:
                 <Select
                    options={employeeOptions}
                    id="DeliveryEmployee"
                    name="DeliveryEmployee"
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    className="custom-search-select"           
                 />
                </div>

              </div>
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Task;
